package com.karawek.core.auth.presenter

import com.karawek.core.auth.model.EmptyOtpHandle
import com.karawek.core.auth.model.OtpHandle
import com.karawek.core.auth.screen.OtpVerificationResult
import com.karawek.core.auth.screen.OtpVerificationScreen
import com.karawek.core.auth.usecase.InitiateOtpUseCase
import com.karawek.core.auth.usecase.SaveAuthSessionUseCase
import com.karawek.core.auth.usecase.VerifyOtpUseCase
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.Navigator
import me.tatarka.inject.annotations.Assisted
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = OtpVerificationScreen::class,
    scope = AppScope::class,
)
@Inject
class OtpVerificationPresenter(
    @Assisted private val screen: OtpVerificationScreen,
    @Assisted navigator: Navigator,
    private val initiateOtp: InitiateOtpUseCase,
    private val verifyOtp: VerifyOtpUseCase,
    private val saveAuthSession: SaveAuthSessionUseCase,
) : BaseOtpVerificationPresenter(
    channel = screen.channel,
    destination = screen.destination,
    navigator = navigator,
) {

    private var otpHandle: OtpHandle = EmptyOtpHandle

    override suspend fun onSendOtp(): Result<Unit> =
        initiateOtp(
            channel = screen.channel,
            destination = screen.destination,
            loginOrCreate = screen.loginOrCreate,
        ).onSuccess { handle ->
            otpHandle = handle
        }.map { }

    override suspend fun onVerifyOtp(otpCode: String): Result<OtpVerificationResult> =
        verifyOtp(
            handle = otpHandle,
            otpCode = otpCode,
        ).map { authInfo ->
            saveAuthSession(authInfo.session)
            OtpVerificationResult(
                status = OtpVerificationResult.Status.Verified,
                userInfo = authInfo.user,
            )
        }
}
